/* @fflow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EntityTypesDownloadContainer } from 'containers/DownloadContainers';
import { Row } from 'components/UIKit/Flex';

export default class BiospecimenToolbar extends Component {
  static propTypes = {
    router: PropTypes.shape({
      params: PropTypes.shape({ entity: PropTypes.string })
    })
  };

  render(): React.Element {
    const { entity } = this.props.router.params;
    const { location: { query: { id } } } = this.props.router;
    return (
      <Row>
        {!id ? (
          <EntityTypesDownloadContainer customDataTestID="button-download-all" entityTypes={[ entity ]} downloadAll>
            download all
          </EntityTypesDownloadContainer>
        ) : (
          <EntityTypesDownloadContainer customDataTestID="button-download-all">
            download all
          </EntityTypesDownloadContainer>
        )}
      </Row>
    );
  }
}
